<template>
  <div class="invite-header">
    <div v-if="state === 'inviteColleagues'" class="invite-colleagues">
      <span class="title">Invite People</span>
      <span class="description"
        >Add more team members to the Wochit experience</span
      >
    </div>
    <div v-else class="production-line">
      <span class="title">Production Lines</span>
      <span class="description"
        >Select the production lines you wish to assign to these team
        members</span
      >
    </div>
  </div>
</template>

<script>
/**
 *  InviteHeader
 * */
export default {
  props: {
    state: {
      type: String,
      required: true,
    },
  },
};
</script>
